import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'; // redux의 useSelector 임포트
import { NavLink } from 'react-router-dom';

import translations from '../data/translation'; // translations 임포트
import useStoreNo from '../hooks/useStoreNo';
import { isApp } from '../utils/isApp'; // [APP-FORK]

export default function LeftMenu(props) {
  if (isApp()) return null; // [APP-FORK]
  const pageName = props.pageName;
  const userInfo = useSelector(state => state.userInfo);

  // redux의 language 상태 가져오기
  const language = useSelector(state => state.language.language);

  // 현재 언어에 따른 번역 객체 가져오기
  const t = translations[language];

  const storeNo = useStoreNo();
  const canManageStaff =
    userInfo?.role === 'AG001' ||
    (Array.isArray(userInfo?.roles) && userInfo.roles.includes('admin'));

  // 기본 닫힘(작은 화면), 큰 화면(>=1600px)에서만 열림
  const [open, setOpen] = useState(() => {
    try {
      return window.innerWidth >= 1600;
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    const onResize = () => {
      setOpen(window.innerWidth >= 1600);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleItemClick = () => {
    setOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className="leftmenu_toggle_btn"
        onClick={() => setOpen(prev => !prev)}
        aria-expanded={open}
        aria-controls="leftmenu_box"
      >
        ☰
      </button>
      <section
        id="leftmenu_box"
        className={`leftmenu_box ${open ? 'open' : 'closed'}`}
        aria-hidden={!open}
      >
        <nav>
          <ul className="leftmenu_01">
            <li>
              <NavLink
                className={pageName === 'gift' ? 'select' : ''}
                to={storeNo ? `/${storeNo}/gift-list` : '/gift-list'}
                onClick={handleItemClick}
              >
                {t.giftManagement || '기프트 관리'}
              </NavLink>
            </li>
            <li>
              <NavLink
                className={pageName === 'customer' ? 'select' : ''}
                to={
                  storeNo ? `/${storeNo}/customer-manage` : '/customer-manage'
                }
                onClick={handleItemClick}
              >
                {t.customerManagement || '고객 정보 관리'}
              </NavLink>
            </li>
            <li>
              <NavLink
                className={pageName === 'user' ? 'select' : ''}
                to={storeNo ? `/${storeNo}/user-manage` : '/user-manage'}
                onClick={handleItemClick}
              >
                {t.userManagement || '관리자 정보 관리'}
              </NavLink>
            </li>
            {canManageStaff ? (
              <li>
                <NavLink
                  className={pageName === 'staff' ? 'select' : ''}
                  to={storeNo ? `/${storeNo}/staff-manage` : '/staff-manage'}
                  onClick={handleItemClick}
                >
                  {t.staffManagement || '직원 관리'}
                </NavLink>
              </li>
            ) : null}
            <li>
              <NavLink
                className={pageName === 'store' ? 'select' : ''}
                to={storeNo ? `/${storeNo}/store-manage` : '/store-manage'}
                onClick={handleItemClick}
              >
                {t.storeManagement || '상점 정보 관리'}
              </NavLink>
            </li>
            <li>
              <NavLink
                className={pageName === 'notice' ? 'select' : ''}
                to="/mobile/notice"
                onClick={handleItemClick}
              >
                {t.noticeBoardTitle || '공지사항'}
              </NavLink>
            </li>
            {/* 
            <li>
              <NavLink
                className={pageName === 'qna' ? 'select' : ''}
                to={storeNo ? `/${storeNo}/qna-list` : '/qna-list'}
                onClick={handleItemClick}
              >
                {t.serviceInquiry || '서비스 문의'}
              </NavLink>
            </li>
            */}
            {/* 푸시알림 테스트 — 메뉴에서만 숨김(라우트 /:storeNo/marketing-manage 는 유지)
            <li>
              <NavLink
                className={pageName === 'marketing' ? 'select' : ''}
                to={
                  storeNo ? `/${storeNo}/marketing-manage` : '/marketing-manage'
                }
                onClick={handleItemClick}
              >
                {t.pushAlarmTestMenu || '푸시알림 테스트'}
              </NavLink>
            </li>
            */}
          </ul>
        </nav>
      </section>
    </>
  );
}
